import { createComponent } from '@carvana/merch-components';

export const MenuItems = createComponent('div', {
  className: 'flex flex-col divide-y divide-grey-3'
});

const menuItemClasses =
  'flex items-center gap-8 px-32 py-16 tl-header-xs font-bold uppercase';

export const MenuItem = createComponent('div', {
  className: menuItemClasses
});

export const MenuItemAnchor = createComponent('a', {
  className: `${menuItemClasses} text-blue-6 hover:text-blue-3`
});
